import { render, staticRenderFns } from "./goalConfig.vue?vue&type=template&id=0fdcc1cc&scoped=true"
import script from "./goalConfig.vue?vue&type=script&lang=js"
export * from "./goalConfig.vue?vue&type=script&lang=js"
import style0 from "./goalConfig.vue?vue&type=style&index=0&id=0fdcc1cc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdcc1cc",
  null
  
)

export default component.exports